import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { EcaadminDashboardService } from 'src/app/ecaadmin-dashboard/ecaadmin-dashboard.service';
// import {SocketService} from '../../socket.service';
import { EcachatRoomService } from '../ecachatroom.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-ecachat',
  templateUrl: './ecachat.component.html',
  styleUrls: ['./ecachat.component.css']
})
export class EcachatComponent implements OnInit {

  messages=[];
  currentUser = localStorage.getItem('userId');
  newMsg = '';
  sessionIdSubscription: Subscription;
  sessionStatusSubscription: Subscription;
  sessionId='';
  sessionStatus = '';
  replyType=false;
  replyTypeMessage:'';
  replyTypeUserName:'';

  @ViewChild('mainContent') mainContent: ElementRef;

  constructor(
    // public SocketService:SocketService,
    private adminDashboardService:EcaadminDashboardService,
    private chatRoomService:EcachatRoomService,
  ) { }

  ngOnInit() {
    this.replyType=false;
    // this.sessionIdSubscription = this.SocketService.sessionId.subscribe(sessionId => {
    //   this.sessionId=sessionId;
    //   this.getMessageList();
    // });
    // this.sessionStatusSubscription = this.SocketService.sessionStatus.subscribe(sessionStatus => {
    //   console.log(sessionStatus);
    //   this.sessionStatus=sessionStatus;
    //   // this.getMessageList();
    // });
    this.getMessageData();
    // this.getMessageList();
    this.getBroadCastData();
    setTimeout(() => {
      this.scrollToBottom();
    });
  }

  sendMessage() {
    console.log("Send data",this.newMsg,this.sessionId);
    const data= {
      sessionId : this.sessionId,
      senderId : localStorage.getItem('userId'),
      message : this.newMsg,
      replyType:this.replyType,
      replyTypeMessage:this.replyTypeMessage,
      replyTypeUserName:this.replyTypeUserName,
    };
    // this.SocketService.sendTextMesssage(data);
    this.newMsg = '';
    setTimeout(() => {
      this.scrollToBottom();
    });
  }

  scrollToBottom(): void {
    try {
        this.mainContent.nativeElement.scrollTop = this.mainContent.nativeElement.scrollHeight;
    } catch(err) { }
  }

  getMessageData(){
  //   this.SocketService.liveSignalReceiver().subscribe((data)=>{
  //     console.log("Reciever",data)
  //     console.log('Reciever', data);
  //     let datas={
  //       createdAt: data.date,
  //       message:data.message,
  //       senderId: data.senderId,
  //       sessionId: data.sessionId,
  //       senderName:data.senderName,
  //       replyType:data.replyType,
  //       replyTypeMessage:data.replyTypeMessage,
  //       replyTypeUserName:data.replyTypeUserName,
  //     }
  //     this.messages.push(datas);
  //  })
  }

  getBroadCastData(){
    // this.SocketService.recieveBroadCastMessage().subscribe((data)=>{
    //   console.log("BroadCast message",data);
    //   this.getMessageList();
    // })
  }

  getMessageList() {
    console.log("FFFFFFnew ddddk ", this.sessionId);
    this.adminDashboardService.messageList({sessionId: this.sessionId}).subscribe((data:any)=>{
      console.log("message List",data);
      this.messages=data.messageList;
      // this.messages = apiResponse['chatList']
      // console.log(this.messages)
    })
  }
// getdata = () =>{
//   this.SocketService.recieveTextMessage()
//   .subscribe((data)=>{

//     this.getchatList()

//   })
// }

  onSendImage(event) {
    let selectedFile = <File>event.target.files[0];
    if (selectedFile != null) {
      if(selectedFile.size>94913969){
      // this.fileUploadError="*File size should less than 5 mb!";
      // this.loaderSpinner = false;
      }
    else {
      // this.loaderSpinner = true;
      // this.fileUploadError='';
      const fd = new FormData();
      fd.append('image', selectedFile);
      fd.append('imageDocumentName',selectedFile.name);
      fd.append('sessionId',this.sessionId);
      fd.append('senderId',localStorage.getItem('userId'));
      this.chatRoomService.insertImage(fd).subscribe((data:any)=>{
        });
      }
   // this.scrollObject.scroll = true;
    }
  }


  downloadDocument(data){
    this.chatRoomService.downloadDocument({filename: data.data.imageDocumentName, path: data.data.image})
    .subscribe(response => {
      fileSaver.saveAs(response, data.data.imageDocumentName);
    });
  }


  onSendDocument(event) {
    let selectedFile = <File>event.target.files[0];
    if (selectedFile != null) {
      if(selectedFile.size>94913969){
      // this.fileUploadError="*File size should less than 5 mb!";
      // this.loaderSpinner = false;
      }
    else {
      // this.loaderSpinner = true;
      // this.fileUploadError='';
      const fd = new FormData();
      fd.append('document', selectedFile);
      fd.append('imageDocumentName',selectedFile.name);
      fd.append('sessionId',this.sessionId);
      fd.append('senderId',localStorage.getItem('userId'));
      this.chatRoomService.insertDocument(fd).subscribe((data:any)=>{
      });
    }
   // this.scrollObject.scroll = true;
    }
  }

}
